import EggSingleDocument from './EggSingleDocument'

export default EggSingleDocument
